enum StatusCheckinEnum {
    AguardandoCheckin = "A",
    CheckinRealizado = "R",
    CheckinJustificado = "J",
    Dispensado = "D",
    DesabilitadoInterjornada = "I",
    AbonoLegal = "L",
    AbonoAdministrativo = "M",
    DeferidoPeloCordenador = "E",
    IndeferidoPeloCordenador = "F",
    PendenciaJustificativa = "P",
    Compensado = "C",
    DeferidoPelaAdministracao = "G",
    IndeferidoPelaAdministracao = "H",
    AbonoAnalise = "N",
    Recesso = "O",
    FeriadoMunicipal = "Q",
    FeriadoNacional = "V",
    Ferias = "S",
    LicencaRemunerada = "T",
    LicencaNaoRemunerada = "U",
    Inativo = "X",
    Ausencia = "Y",
    AusenciaJustificada = "Z",
}

export type StatusCheckinEnumType = keyof typeof StatusCheckinEnum;

const StatusCheckinEnumLabel = new Map<StatusCheckinEnum, string>([
    [StatusCheckinEnum.AguardandoCheckin, "Aguardando Check-in"],
    [StatusCheckinEnum.CheckinRealizado, "Check-in Realizado"],
    [StatusCheckinEnum.CheckinJustificado, "Check-in Justificado"],
    [StatusCheckinEnum.AbonoLegal, "Abono Legal"],
    [
        StatusCheckinEnum.DesabilitadoInterjornada,
        "Desabilitado por Interjornada",
    ],
    [StatusCheckinEnum.Dispensado, "Dispensado"],
    [StatusCheckinEnum.AbonoAdministrativo, "Abono Administrativo"],
    [StatusCheckinEnum.DeferidoPeloCordenador, "Deferido pela Coordenação"],
    [StatusCheckinEnum.IndeferidoPeloCordenador, "Indeferido pela Coordenação"],
    [StatusCheckinEnum.PendenciaJustificativa, "Pendência de Justificativa"],
    [StatusCheckinEnum.Compensado, "Compensado"],
    [
        StatusCheckinEnum.DeferidoPelaAdministracao,
        "Deferido pela Administração",
    ],
    [
        StatusCheckinEnum.IndeferidoPelaAdministracao,
        "Indeferido pela Administração",
    ],
    [StatusCheckinEnum.AbonoAnalise, "Abono em Análise"],
    [StatusCheckinEnum.Recesso, "Recesso"],
    [StatusCheckinEnum.FeriadoMunicipal, "Feriado Municipal"],
    [StatusCheckinEnum.FeriadoNacional, "Feriado Nacional"],
    [StatusCheckinEnum.Ferias, "Férias"],
    [StatusCheckinEnum.LicencaRemunerada, "Licença Remunerada"],
    [StatusCheckinEnum.LicencaNaoRemunerada, "Licença Não Remunerada"],
    [StatusCheckinEnum.Inativo, "Inativo"],
    [StatusCheckinEnum.Ausencia, "Ausência"],
    [StatusCheckinEnum.AusenciaJustificada, "Ausência Justificada"],
]);

export const getLabelStatusCheckinEnum = (value: StatusCheckinEnum) => {
    return StatusCheckinEnumLabel.get(value) || "";
};

export { StatusCheckinEnum, StatusCheckinEnumLabel };
